import React, { useEffect, useRef, useState } from "react";
import { Checkbox, Col, Modal, Row, Tooltip } from "antd";
import { Close, Description, DownloadOutlined, History } from "@mui/icons-material";
import moment from "moment";
import { IMAGE_HOST } from "../../../../../constant";
import { BeatLoader } from "react-spinners";

const TaskDetail = ({
  preview,
  previewHandler,
  data,
  editHandler,
  deleteHandler,
  historyHandler,
}) => {
  // STATES
  const [isCompleted, setCompleted] = useState(false);
  const [downloadLoader, setdownloadLoader] = useState([]);

  // CONST VALS
  const { http } = global.services;

  // HANDLERS
  const downloadAttachment = (file) => {
    setdownloadLoader((prev) => [...prev, file.id]);

    fetch(IMAGE_HOST + file.path, {
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", file.name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {})
      .finally(() => {
        setdownloadLoader((prev) => prev.filter((item) => item !== file.id));
      });
  };
  const markCompleteHandler = (e) => {
    const val = e.checked;
    setCompleted(val);
    http
      .post(`company-task-complete/${data.id}`, { completed: val })
      .then(() => {})
      .catch(() => {
        setCompleted(!val);
      });
  };

  // HOOKS
  useEffect(() => {
    setCompleted(data?.is_completed);
  }, [data]);

  return (
    <Modal
      visible={preview}
      centered
      className="task-detail-modal"
      footer={null}
      onCancel={previewHandler}
      closable={false}
      width={850}
    >
      <button className="close-btn" onClick={previewHandler}>
        <Close />
      </button>
      <h2>Task Details</h2>
      <Row gutter={[24, 24]}>
        <Col span={14}>
          <h4>Task Name</h4>
          <p className={`${isCompleted ? "deleted" : ""}`}>{data?.title}</p>
          <h4>Description</h4>
          <p>{data?.description}</p>
          <div className="mark-complete">
            <Checkbox
              checked={isCompleted}
              onChange={({ target }) => markCompleteHandler(target)}
            >
              {data?.is_completed ? "Mark as incomplete" : "Mark as complete"}
            </Checkbox>
          </div>
        </Col>
        <Col span={10}>
          <div className="right-box">
            <button className="history-toggle" onClick={historyHandler}>
              <History /> History
            </button>
            <div className="actions">
              <div className="action-item">
                <h5>Status</h5>
                <h6>{data?.status?.name}</h6>
              </div>
              <div className="action-item">
                <h5>Start Date</h5>
                <h6>
                  {data?.start_date
                    ? moment(data?.start_date).format("MMMM DD, YYYY")
                    : "-"}
                </h6>
              </div>
              <div className="action-item">
                <h5>End Date</h5>
                <h6>
                  {data?.end_date ? moment(data?.end_date).format("MMMM DD, YYYY") : "-"}
                </h6>
              </div>
              <div className="action-item">
                <h5>Assign to</h5>
                <h6>
                  {data?.task_assignees?.length >= 1
                    ? data?.task_assignees?.map(({ assignee }) => (
                        <span>{assignee?.username}</span>
                      ))
                    : "Unassigned"}
                </h6>
              </div>
              <div className="action-item">
                <h5>Created By</h5>
                <h6>{data?.created_by?.username}</h6>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {data?.task_attachments?.length >= 1 && (
        <>
          <h4>Attachments</h4>
          <div className="attachments-wrapper">
            {data?.task_attachments?.map((file, index) => (
              <div key={index} className="file-box">
                <div className="preview">
                  {file?.file_type?.includes("image") ? (
                    <img src={IMAGE_HOST + file.path} alt="" />
                  ) : file?.file_type?.includes("pdf") ? (
                    <object data={IMAGE_HOST + file.path} type="application/pdf">
                      <embed src={IMAGE_HOST + file.path} type="application/pdf" />
                    </object>
                  ) : (
                    <Description />
                  )}
                </div>
                {file.name.length > 20 ? (
                  <Tooltip title={file.name}>
                    <p>{file.name.slice(0, 20)}...</p>
                  </Tooltip>
                ) : (
                  <p>{file.name}</p>
                )}
                <div className="overlay">
                  <button
                    disabled={downloadLoader.includes(file.id)}
                    onClick={() => downloadAttachment(file)}
                  >
                    {downloadLoader.includes(data.id) ? (
                      <BeatLoader size={3} />
                    ) : (
                      <DownloadOutlined />
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      <div className="action-box">
        <button onClick={deleteHandler}>Delete</button>
        <button onClick={editHandler}>Edit</button>
      </div>
    </Modal>
  );
};

export default TaskDetail;
